/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ApiHomeRouteImport } from './routes/api-home'
import { Route as WorkflowRouteRouteImport } from './routes/workflow/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkflowIndexRouteImport } from './routes/workflow/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as KeyManagementIndexRouteImport } from './routes/key-management/index'
import { Route as AnalysesIndexRouteImport } from './routes/analyses/index'
import { Route as WorkflowLayoutRouteImport } from './routes/workflow/_layout'
import { Route as TemplatesNewRouteImport } from './routes/templates/new'
import { Route as KeyManagementSpecificationRouteImport } from './routes/key-management/specification'
import { Route as KeyManagementRoutePermissionsRouteImport } from './routes/key-management/route-permissions'
import { Route as KeyManagementApiKeysRouteImport } from './routes/key-management/api-keys'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as ClientsClientsRouteImport } from './routes/clients/clients'
import { Route as ClientsClientIdRouteImport } from './routes/clients/$clientId'
import { Route as BillingBillingDashboardRouteImport } from './routes/billing/billing-dashboard'
import { Route as BillingClientIdRouteImport } from './routes/billing/$clientId'
import { Route as AnalysesIdRouteImport } from './routes/analyses/$id'
import { Route as WorkflowLayoutUploadRouteImport } from './routes/workflow/_layout/upload'
import { Route as WorkflowLayoutSummaryRouteImport } from './routes/workflow/_layout/summary'
import { Route as WorkflowLayoutReportRouteImport } from './routes/workflow/_layout/report'
import { Route as WorkflowLayoutOverridesRouteImport } from './routes/workflow/_layout/overrides'
import { Route as WorkflowLayoutMetricsRouteImport } from './routes/workflow/_layout/metrics'
import { Route as WorkflowLayoutGenerateRouteImport } from './routes/workflow/_layout/generate'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiHomeRoute = ApiHomeRouteImport.update({
  id: '/api-home',
  path: '/api-home',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowRouteRoute = WorkflowRouteRouteImport.update({
  id: '/workflow',
  path: '/workflow',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowIndexRoute = WorkflowIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkflowRouteRoute,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const KeyManagementIndexRoute = KeyManagementIndexRouteImport.update({
  id: '/key-management/',
  path: '/key-management/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysesIndexRoute = AnalysesIndexRouteImport.update({
  id: '/analyses/',
  path: '/analyses/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowLayoutRoute = WorkflowLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => WorkflowRouteRoute,
} as any)
const TemplatesNewRoute = TemplatesNewRouteImport.update({
  id: '/templates/new',
  path: '/templates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const KeyManagementSpecificationRoute =
  KeyManagementSpecificationRouteImport.update({
    id: '/key-management/specification',
    path: '/key-management/specification',
    getParentRoute: () => rootRouteImport,
  } as any)
const KeyManagementRoutePermissionsRoute =
  KeyManagementRoutePermissionsRouteImport.update({
    id: '/key-management/route-permissions',
    path: '/key-management/route-permissions',
    getParentRoute: () => rootRouteImport,
  } as any)
const KeyManagementApiKeysRoute = KeyManagementApiKeysRouteImport.update({
  id: '/key-management/api-keys',
  path: '/key-management/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientsRoute = ClientsClientsRouteImport.update({
  id: '/clients/clients',
  path: '/clients/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingBillingDashboardRoute = BillingBillingDashboardRouteImport.update({
  id: '/billing/billing-dashboard',
  path: '/billing/billing-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingClientIdRoute = BillingClientIdRouteImport.update({
  id: '/billing/$clientId',
  path: '/billing/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysesIdRoute = AnalysesIdRouteImport.update({
  id: '/analyses/$id',
  path: '/analyses/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowLayoutUploadRoute = WorkflowLayoutUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => WorkflowLayoutRoute,
} as any)
const WorkflowLayoutSummaryRoute = WorkflowLayoutSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => WorkflowLayoutRoute,
} as any)
const WorkflowLayoutReportRoute = WorkflowLayoutReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => WorkflowLayoutRoute,
} as any)
const WorkflowLayoutOverridesRoute = WorkflowLayoutOverridesRouteImport.update({
  id: '/overrides',
  path: '/overrides',
  getParentRoute: () => WorkflowLayoutRoute,
} as any)
const WorkflowLayoutMetricsRoute = WorkflowLayoutMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => WorkflowLayoutRoute,
} as any)
const WorkflowLayoutGenerateRoute = WorkflowLayoutGenerateRouteImport.update({
  id: '/generate',
  path: '/generate',
  getParentRoute: () => WorkflowLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/workflow': typeof WorkflowLayoutRouteWithChildren
  '/api-home': typeof ApiHomeRoute
  '/dashboard': typeof DashboardRoute
  '/settings': typeof SettingsRoute
  '/analyses/$id': typeof AnalysesIdRoute
  '/billing/$clientId': typeof BillingClientIdRoute
  '/billing/billing-dashboard': typeof BillingBillingDashboardRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/clients/clients': typeof ClientsClientsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/key-management/api-keys': typeof KeyManagementApiKeysRoute
  '/key-management/route-permissions': typeof KeyManagementRoutePermissionsRoute
  '/key-management/specification': typeof KeyManagementSpecificationRoute
  '/templates/new': typeof TemplatesNewRoute
  '/analyses': typeof AnalysesIndexRoute
  '/key-management': typeof KeyManagementIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/workflow/': typeof WorkflowIndexRoute
  '/workflow/generate': typeof WorkflowLayoutGenerateRoute
  '/workflow/metrics': typeof WorkflowLayoutMetricsRoute
  '/workflow/overrides': typeof WorkflowLayoutOverridesRoute
  '/workflow/report': typeof WorkflowLayoutReportRoute
  '/workflow/summary': typeof WorkflowLayoutSummaryRoute
  '/workflow/upload': typeof WorkflowLayoutUploadRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/api-home': typeof ApiHomeRoute
  '/dashboard': typeof DashboardRoute
  '/settings': typeof SettingsRoute
  '/analyses/$id': typeof AnalysesIdRoute
  '/billing/$clientId': typeof BillingClientIdRoute
  '/billing/billing-dashboard': typeof BillingBillingDashboardRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/clients/clients': typeof ClientsClientsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/key-management/api-keys': typeof KeyManagementApiKeysRoute
  '/key-management/route-permissions': typeof KeyManagementRoutePermissionsRoute
  '/key-management/specification': typeof KeyManagementSpecificationRoute
  '/templates/new': typeof TemplatesNewRoute
  '/workflow': typeof WorkflowIndexRoute
  '/analyses': typeof AnalysesIndexRoute
  '/key-management': typeof KeyManagementIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/workflow/generate': typeof WorkflowLayoutGenerateRoute
  '/workflow/metrics': typeof WorkflowLayoutMetricsRoute
  '/workflow/overrides': typeof WorkflowLayoutOverridesRoute
  '/workflow/report': typeof WorkflowLayoutReportRoute
  '/workflow/summary': typeof WorkflowLayoutSummaryRoute
  '/workflow/upload': typeof WorkflowLayoutUploadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/workflow': typeof WorkflowRouteRouteWithChildren
  '/api-home': typeof ApiHomeRoute
  '/dashboard': typeof DashboardRoute
  '/settings': typeof SettingsRoute
  '/analyses/$id': typeof AnalysesIdRoute
  '/billing/$clientId': typeof BillingClientIdRoute
  '/billing/billing-dashboard': typeof BillingBillingDashboardRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/clients/clients': typeof ClientsClientsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/key-management/api-keys': typeof KeyManagementApiKeysRoute
  '/key-management/route-permissions': typeof KeyManagementRoutePermissionsRoute
  '/key-management/specification': typeof KeyManagementSpecificationRoute
  '/templates/new': typeof TemplatesNewRoute
  '/workflow/_layout': typeof WorkflowLayoutRouteWithChildren
  '/analyses/': typeof AnalysesIndexRoute
  '/key-management/': typeof KeyManagementIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/workflow/': typeof WorkflowIndexRoute
  '/workflow/_layout/generate': typeof WorkflowLayoutGenerateRoute
  '/workflow/_layout/metrics': typeof WorkflowLayoutMetricsRoute
  '/workflow/_layout/overrides': typeof WorkflowLayoutOverridesRoute
  '/workflow/_layout/report': typeof WorkflowLayoutReportRoute
  '/workflow/_layout/summary': typeof WorkflowLayoutSummaryRoute
  '/workflow/_layout/upload': typeof WorkflowLayoutUploadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/workflow'
    | '/api-home'
    | '/dashboard'
    | '/settings'
    | '/analyses/$id'
    | '/billing/$clientId'
    | '/billing/billing-dashboard'
    | '/clients/$clientId'
    | '/clients/clients'
    | '/invite/$token'
    | '/key-management/api-keys'
    | '/key-management/route-permissions'
    | '/key-management/specification'
    | '/templates/new'
    | '/analyses'
    | '/key-management'
    | '/templates'
    | '/workflow/'
    | '/workflow/generate'
    | '/workflow/metrics'
    | '/workflow/overrides'
    | '/workflow/report'
    | '/workflow/summary'
    | '/workflow/upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/api-home'
    | '/dashboard'
    | '/settings'
    | '/analyses/$id'
    | '/billing/$clientId'
    | '/billing/billing-dashboard'
    | '/clients/$clientId'
    | '/clients/clients'
    | '/invite/$token'
    | '/key-management/api-keys'
    | '/key-management/route-permissions'
    | '/key-management/specification'
    | '/templates/new'
    | '/workflow'
    | '/analyses'
    | '/key-management'
    | '/templates'
    | '/workflow/generate'
    | '/workflow/metrics'
    | '/workflow/overrides'
    | '/workflow/report'
    | '/workflow/summary'
    | '/workflow/upload'
  id:
    | '__root__'
    | '/'
    | '/workflow'
    | '/api-home'
    | '/dashboard'
    | '/settings'
    | '/analyses/$id'
    | '/billing/$clientId'
    | '/billing/billing-dashboard'
    | '/clients/$clientId'
    | '/clients/clients'
    | '/invite/$token'
    | '/key-management/api-keys'
    | '/key-management/route-permissions'
    | '/key-management/specification'
    | '/templates/new'
    | '/workflow/_layout'
    | '/analyses/'
    | '/key-management/'
    | '/templates/'
    | '/workflow/'
    | '/workflow/_layout/generate'
    | '/workflow/_layout/metrics'
    | '/workflow/_layout/overrides'
    | '/workflow/_layout/report'
    | '/workflow/_layout/summary'
    | '/workflow/_layout/upload'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WorkflowRouteRoute: typeof WorkflowRouteRouteWithChildren
  ApiHomeRoute: typeof ApiHomeRoute
  DashboardRoute: typeof DashboardRoute
  SettingsRoute: typeof SettingsRoute
  AnalysesIdRoute: typeof AnalysesIdRoute
  BillingClientIdRoute: typeof BillingClientIdRoute
  BillingBillingDashboardRoute: typeof BillingBillingDashboardRoute
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  ClientsClientsRoute: typeof ClientsClientsRoute
  InviteTokenRoute: typeof InviteTokenRoute
  KeyManagementApiKeysRoute: typeof KeyManagementApiKeysRoute
  KeyManagementRoutePermissionsRoute: typeof KeyManagementRoutePermissionsRoute
  KeyManagementSpecificationRoute: typeof KeyManagementSpecificationRoute
  TemplatesNewRoute: typeof TemplatesNewRoute
  AnalysesIndexRoute: typeof AnalysesIndexRoute
  KeyManagementIndexRoute: typeof KeyManagementIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-home': {
      id: '/api-home'
      path: '/api-home'
      fullPath: '/api-home'
      preLoaderRoute: typeof ApiHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow': {
      id: '/workflow'
      path: '/workflow'
      fullPath: '/workflow'
      preLoaderRoute: typeof WorkflowRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow/': {
      id: '/workflow/'
      path: '/'
      fullPath: '/workflow/'
      preLoaderRoute: typeof WorkflowIndexRouteImport
      parentRoute: typeof WorkflowRouteRoute
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/key-management/': {
      id: '/key-management/'
      path: '/key-management'
      fullPath: '/key-management'
      preLoaderRoute: typeof KeyManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analyses/': {
      id: '/analyses/'
      path: '/analyses'
      fullPath: '/analyses'
      preLoaderRoute: typeof AnalysesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow/_layout': {
      id: '/workflow/_layout'
      path: ''
      fullPath: '/workflow'
      preLoaderRoute: typeof WorkflowLayoutRouteImport
      parentRoute: typeof WorkflowRouteRoute
    }
    '/templates/new': {
      id: '/templates/new'
      path: '/templates/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof TemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/key-management/specification': {
      id: '/key-management/specification'
      path: '/key-management/specification'
      fullPath: '/key-management/specification'
      preLoaderRoute: typeof KeyManagementSpecificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/key-management/route-permissions': {
      id: '/key-management/route-permissions'
      path: '/key-management/route-permissions'
      fullPath: '/key-management/route-permissions'
      preLoaderRoute: typeof KeyManagementRoutePermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/key-management/api-keys': {
      id: '/key-management/api-keys'
      path: '/key-management/api-keys'
      fullPath: '/key-management/api-keys'
      preLoaderRoute: typeof KeyManagementApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/clients': {
      id: '/clients/clients'
      path: '/clients/clients'
      fullPath: '/clients/clients'
      preLoaderRoute: typeof ClientsClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/billing-dashboard': {
      id: '/billing/billing-dashboard'
      path: '/billing/billing-dashboard'
      fullPath: '/billing/billing-dashboard'
      preLoaderRoute: typeof BillingBillingDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/$clientId': {
      id: '/billing/$clientId'
      path: '/billing/$clientId'
      fullPath: '/billing/$clientId'
      preLoaderRoute: typeof BillingClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analyses/$id': {
      id: '/analyses/$id'
      path: '/analyses/$id'
      fullPath: '/analyses/$id'
      preLoaderRoute: typeof AnalysesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow/_layout/upload': {
      id: '/workflow/_layout/upload'
      path: '/upload'
      fullPath: '/workflow/upload'
      preLoaderRoute: typeof WorkflowLayoutUploadRouteImport
      parentRoute: typeof WorkflowLayoutRoute
    }
    '/workflow/_layout/summary': {
      id: '/workflow/_layout/summary'
      path: '/summary'
      fullPath: '/workflow/summary'
      preLoaderRoute: typeof WorkflowLayoutSummaryRouteImport
      parentRoute: typeof WorkflowLayoutRoute
    }
    '/workflow/_layout/report': {
      id: '/workflow/_layout/report'
      path: '/report'
      fullPath: '/workflow/report'
      preLoaderRoute: typeof WorkflowLayoutReportRouteImport
      parentRoute: typeof WorkflowLayoutRoute
    }
    '/workflow/_layout/overrides': {
      id: '/workflow/_layout/overrides'
      path: '/overrides'
      fullPath: '/workflow/overrides'
      preLoaderRoute: typeof WorkflowLayoutOverridesRouteImport
      parentRoute: typeof WorkflowLayoutRoute
    }
    '/workflow/_layout/metrics': {
      id: '/workflow/_layout/metrics'
      path: '/metrics'
      fullPath: '/workflow/metrics'
      preLoaderRoute: typeof WorkflowLayoutMetricsRouteImport
      parentRoute: typeof WorkflowLayoutRoute
    }
    '/workflow/_layout/generate': {
      id: '/workflow/_layout/generate'
      path: '/generate'
      fullPath: '/workflow/generate'
      preLoaderRoute: typeof WorkflowLayoutGenerateRouteImport
      parentRoute: typeof WorkflowLayoutRoute
    }
  }
}

interface WorkflowLayoutRouteChildren {
  WorkflowLayoutGenerateRoute: typeof WorkflowLayoutGenerateRoute
  WorkflowLayoutMetricsRoute: typeof WorkflowLayoutMetricsRoute
  WorkflowLayoutOverridesRoute: typeof WorkflowLayoutOverridesRoute
  WorkflowLayoutReportRoute: typeof WorkflowLayoutReportRoute
  WorkflowLayoutSummaryRoute: typeof WorkflowLayoutSummaryRoute
  WorkflowLayoutUploadRoute: typeof WorkflowLayoutUploadRoute
}

const WorkflowLayoutRouteChildren: WorkflowLayoutRouteChildren = {
  WorkflowLayoutGenerateRoute: WorkflowLayoutGenerateRoute,
  WorkflowLayoutMetricsRoute: WorkflowLayoutMetricsRoute,
  WorkflowLayoutOverridesRoute: WorkflowLayoutOverridesRoute,
  WorkflowLayoutReportRoute: WorkflowLayoutReportRoute,
  WorkflowLayoutSummaryRoute: WorkflowLayoutSummaryRoute,
  WorkflowLayoutUploadRoute: WorkflowLayoutUploadRoute,
}

const WorkflowLayoutRouteWithChildren = WorkflowLayoutRoute._addFileChildren(
  WorkflowLayoutRouteChildren,
)

interface WorkflowRouteRouteChildren {
  WorkflowLayoutRoute: typeof WorkflowLayoutRouteWithChildren
  WorkflowIndexRoute: typeof WorkflowIndexRoute
}

const WorkflowRouteRouteChildren: WorkflowRouteRouteChildren = {
  WorkflowLayoutRoute: WorkflowLayoutRouteWithChildren,
  WorkflowIndexRoute: WorkflowIndexRoute,
}

const WorkflowRouteRouteWithChildren = WorkflowRouteRoute._addFileChildren(
  WorkflowRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkflowRouteRoute: WorkflowRouteRouteWithChildren,
  ApiHomeRoute: ApiHomeRoute,
  DashboardRoute: DashboardRoute,
  SettingsRoute: SettingsRoute,
  AnalysesIdRoute: AnalysesIdRoute,
  BillingClientIdRoute: BillingClientIdRoute,
  BillingBillingDashboardRoute: BillingBillingDashboardRoute,
  ClientsClientIdRoute: ClientsClientIdRoute,
  ClientsClientsRoute: ClientsClientsRoute,
  InviteTokenRoute: InviteTokenRoute,
  KeyManagementApiKeysRoute: KeyManagementApiKeysRoute,
  KeyManagementRoutePermissionsRoute: KeyManagementRoutePermissionsRoute,
  KeyManagementSpecificationRoute: KeyManagementSpecificationRoute,
  TemplatesNewRoute: TemplatesNewRoute,
  AnalysesIndexRoute: AnalysesIndexRoute,
  KeyManagementIndexRoute: KeyManagementIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
